<template>
  <div class="report-resources">
    <a-card size="small" title="报表资源配置">
      <div slot="extra">
        <a-button size="small" :loading="loading" :disabled="saving" @click="load">刷新</a-button>
        <a-button size="small" type="primary" :loading="saving" :disabled="loading || !form" @click="save">保存并生效</a-button>
      </div>
      <a-alert v-if="status" :type="status.enabled && status.configHealthy ? 'info' : 'warning'" show-icon
               :message="status.enabled ? '已启用隔离 · 本机参数版本 ' + form.version : '隔离尚未启用，保存参数后仍需部署启用'"
               description="保存后新准入任务使用新参数，其他实例最多约5秒刷新。调小并发不会终止已运行任务；调小队列会拒绝超出容量的等待任务。"/>
      <a-alert v-if="status && (status.configError || status.cancellationFault)" type="error" show-icon
               :message="status.configError || 'SQL取消异常，当前已停止准入，请管理员核查数据库执行状态'"/>
      <div v-if="status" class="summary">
        查询运行 {{ status.runningQueries }} / 排队 {{ status.queuedQueries }}；
        导出运行 {{ status.runningExports }} / 排队 {{ status.queuedExports }}；
        连接池 {{ status.pool.initialized ? '已初始化' : '未初始化' }}
        <span v-if="status.pool.initialized">（活跃 {{ status.pool.active }}，空闲 {{ status.pool.idle }}，上限 {{ status.pool.maxActive }}）</span>
      </div>
      <a-form v-if="form" layout="vertical">
        <a-form-item label="已验证的报表ID白名单（逗号分隔；空白时所有报表暂停，不能填写通配符）">
          <a-textarea v-model="allowedIds" :rows="2"/>
        </a-form-item>
        <a-form-item label="允许无日期查询的报表ID（如当前库存；必须在上述白名单内并已验证规模限制）">
          <a-textarea v-model="undatedIds" :rows="2"/>
        </a-form-item>
        <div class="switches">
          <label>允许新查询 <a-switch v-model="form.queryAccepting"/></label>
          <label>允许新导出 <a-switch v-model="form.exportAccepting"/></label>
        </div>
        <a-row :gutter="16">
          <a-col v-for="field in fields" :key="field.key" :xs="24" :sm="12" :lg="8">
            <a-form-item :label="field.label">
              <a-input-number v-model="form[field.key]" :min="field.min" :max="field.max" :precision="0" style="width:100%"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-card>
  </div>
</template>
<script>
import {getAction, postAction} from '@/api/manage'
const spec = [
  ['poolSize', '报表池最大连接数', 2, 32],
  ['queryConcurrency', '查询执行并发', 1, 16], ['exportConcurrency', '导出执行并发', 1, 16],
  ['queryQueue', '查询等待队列容量', 0, 100], ['exportQueue', '导出等待队列容量', 0, 20],
  ['userQueryLimit', '单用户查询占位', 1, 8], ['userExportLimit', '单用户导出占位', 1, 4],
  ['reportConcurrency', '单报表执行并发', 1, 32],
  ['queryQueueSeconds', '查询排队时限（秒）', 1, 30], ['exportQueueSeconds', '导出排队时限（秒）', 1, 60],
  ['querySeconds', '查询总预算（秒）', 2, 300], ['exportSeconds', '导出总预算（秒）', 2, 600],
  ['sqlSeconds', '单SQL时限（秒）', 1, 120], ['connectionWaitMillis', '借连接等待（毫秒）', 100, 5000],
  ['maxSqlCount', '单任务SQL条数', 1, 200], ['pageRows', '交互分页最大行数', 1, 5000],
  ['resultRows', '查询结果最大行数', 1, 100000], ['exportRows', '导出最大数据行数', 1, 100000],
  ['intermediateRows', '累计中间读取行数', 1, 500000], ['resultColumns', '结果最大列数', 1, 1000],
  ['resultCells', '结果最大单元格数', 1, 5000000], ['resultBytes', '结果/文件字节上限', 1024, 104857600],
  ['maxInItems', '单个筛选集合最大项数', 1, 10000], ['maxDateDays', '查询日期最大天数', 1, 3660]
]
export default {
  name: 'ReportResourceConfig',
  data: () => ({form: null, allowedIds: '', undatedIds: '', status: null, loading: false, saving: false, fields: spec.map(([key, label, min, max]) => ({key, label, min, max}))}),
  mounted() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await getAction('/sys/reportResources', {})
        if (!res.success) throw new Error(res.message || '无权查看报表资源配置')
        this.status = res.result
        this.form = JSON.parse(JSON.stringify(res.result.limits))
        this.allowedIds = (this.form.allowedReportIds || []).join(',')
        this.undatedIds = (this.form.allowUndatedReportIds || []).join(',')
      } catch (e) { this.$message.error(e.message || '读取失败') } finally { this.loading = false }
    },
    async save() {
      this.form.allowedReportIds = this.allowedIds.split(',').map(v => v.trim()).filter(Boolean)
      this.form.allowUndatedReportIds = this.undatedIds.split(',').map(v => v.trim()).filter(Boolean)
      if (this.form.queryConcurrency + this.form.exportConcurrency > this.form.poolSize) {
        this.$message.warning('查询与导出并发之和不能超过连接数'); return
      }
      this.saving = true
      try {
        const res = await postAction('/sys/reportResources', this.form)
        if (!res.success) throw new Error(res.message || '保存失败')
        this.status = res.result
        this.form = JSON.parse(JSON.stringify(res.result.limits))
        this.$message.success('配置已保存，本机已接受新版本')
      } catch (e) { this.$message.error(e.message || '保存失败，请刷新核对版本') } finally { this.saving = false }
    }
  }
}
</script>
<style scoped>
.report-resources {padding:8px;background:#f5f5f5;min-height:100%;}
.report-resources .ant-btn + .ant-btn {margin-left:8px;}
.summary {margin:12px 0;color:#595959;}
.switches {display:flex;gap:24px;margin:16px 0;flex-wrap:wrap;}
.report-resources .ant-alert + .ant-alert {margin-top:8px;}
</style>
